module.exports = __webpack_public_path__ + "img/backgroundImageRed.6ace877b.jpg";